export const SET_SHOULD_SEE_DEVICE_ROOTED_WARNING_MODAL = 'SET_SHOULD_SEE_DEVICE_ROOTED_WARNING_MODAL';
export const SET_AD_ACTION = 'SET_ADS_ACTION';
export const CLEAR_ADS_ACTION = 'CLEAR_ADS_ACTION';
export const SET_HAS_SHOWN_EMMA_PRO_MODAL = 'SET_HAS_SHOWN_EMMA_PRO_MODAL';
